import { Fragment } from 'react';

import useProfileFunFacts from './UseProfileFunFacts';

import FunFactsFormGrid from '../../../components/grids/funFactsForm/FunFactsFormGrid';

import Headings from '@usas/ui-web/components/headings/Headings';
import PopUpModal from '@usas/ui-web/components/dialogs/PopUpModal';

import { LOADING_MSG } from '@usas/ui-web/utils/Constants';

const ProfileFunFacts = () => {
  const {
    isLoading,
    personId,
    gridData,
    onSubmitFunFactsForm
  } = useProfileFunFacts();

  return (
    <Fragment>
      <div className="row">
        <div className="col-xs-12">
          <Headings.H3>Fun Facts</Headings.H3>
        </div>
      </div>
      <div className="row usas-extra-top-margin usas-extra-bottom-margin">
        <div className="col-xs-12">
          <FunFactsFormGrid
            gridData={gridData}
            personId={personId}
            onSubmitFormCallback={onSubmitFunFactsForm} />
        </div>
      </div>
      <PopUpModal
        widthPct={50}
        maxWidth={250}
        title={LOADING_MSG}
        displayPopUp={isLoading} />
    </Fragment>
  );
};

export default ProfileFunFacts;